export default "__VITE_ASSET__BKYHY_XO__"